import {actionTypes} from './constants'

export const setMode = (mode) => ({
  type: actionTypes.SET_MODE,
  payload: {
    mode,
  }
})

export const postMessage = ({message, isError}) => ({
  type: actionTypes.POST_MESSAGE,
  payload: {
    text: message,
    isError
  },
})

export const setGuestBlocked = (guestBlocked) => ({
  type: actionTypes.SET_GUEST_BLOCKED,
  payload: {
    guestBlocked,
  },
})
